import {
  fcheck_null_undefine_replace_empty,
  fAlertToast,
} from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import {
  common_groupstructure_GETROW,
  common_brandgroup_GETROW,
  common_brandbasedgroup_GETROW,
  common_LocationSearch_GETROW,
  common_BinAttributes_GETROW,
  common_VendorListReport_GETROW,
  common_ItemsSearchReport_GETROW,
  common_ItemsAnalsys_GETROW,
} from "../../Server/ApiV2";
import { fExecuteAPI } from "../../Server/Apis.jsx";

export const sWebStockReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebStockReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];

export const sExpiryData = [
  { Uid: "Summary", Value: "Summary" },
  { Uid: "DETAIL", Value: "Detail" },
  { Uid: "Supplier", Value: "Supplierwise Summary" },
  { Uid: "Dept", Value: "Departmentwise Summary" },
  { Uid: "SubDept", Value: "Sub Departmentwise Summary" },
  { Uid: "Cat", Value: "Categorywise" },
  { Uid: "Brand", Value: "Brandwise Summary" },
];
export const sDueData = [
  { Uid: "DETAIL", Value: "Detail" },
  { Uid: "CONS", Value: "Itemwise" },
  { Uid: "BRAND", Value: "Brandwise" },
  { Uid: "MAIN_GRP", Value: "MainGrpwise" },
  { Uid: "SUB_GRP", Value: "SubGrpwise" },
  { Uid: "GRP", Value: "Grpwise" },
  { Uid: "SUPPLIER", Value: "Supplierwise" },
];

export const NearExpirData = [
  { Uid: "NR_EXP_ITEMS", Value: "Summary" },
  { Uid: "NR_EXP_DETAIL", Value: "Detail" },
  { Uid: "NR_EXP_SUPPLIER", Value: "Supplierwise Summary" },
  { Uid: "NR_EXP_MAIN_GRP", Value: "Departmentwise Summary" },
  { Uid: "NR_EXP_SUB_GRP", Value: "Sub Departmentwise Summary" },
  { Uid: "NR_EXP_GRP", Value: "Categorywise" },
  { Uid: "NR_EXP_BRAND", Value: "Brandwise Summary" },
];
export const ExpiredItemData = [
  { Uid: "EXPIRED_ITEMS", Value: "Summary" },
  { Uid: "EXPIRED_DETAIL", Value: "Detail" },
  { Uid: "EXPIRED_SUPPLIER", Value: "Supplierwise Summary" },
  { Uid: "EXPIRED_MAIN_GRP", Value: "Departmentwise Summary" },
  { Uid: "EXPIRED_SUB_GRP", Value: "Sub Departmentwise Summary" },
  { Uid: "EXPIRED_GRP", Value: "Categorywise" },
  { Uid: "EXPIRED_BRAND", Value: "Brandwise Summary" },
];

export const BinwiseStockOverDueData = [
  { Uid: "OVER_DUE_DETAIL", Value: "Detail" },
  { Uid: "OVER_DUE_ITEMS", Value: "Itemwise" },
  { Uid: "OVER_DUE_BRAND", Value: "Brandwise" },
  { Uid: "OVER_DUE_MAIN_GRP", Value: "MainGrpwise" },
  { Uid: "OVER_DUE_SUB_GRP", Value: "SubGrpwise" },
  { Uid: "OVER_DUE_GRP", Value: "Grpwise" },
  { Uid: "OVER_DUE_SUPPLIER", Value: "Supplierwise" },
];

export const BinwiseStockPaidData = [
  { Uid: "OVER_DUE_PAID_DETAIL", Value: "Detail" },
  { Uid: "OVER_DUE_PAID_ITEMS", Value: "Itemwise" },
  { Uid: "OVER_DUE_PAID_BRAND", Value: "Brandwise" },
  { Uid: "OVER_DUE_PAID_MAIN_GRP", Value: "MainGrpwise" },
  { Uid: "OVER_DUE_PAID_SUB_GRP", Value: "SubGrpwise" },
  { Uid: "OVER_DUE_PAID_GRP", Value: "Grpwise" },
  { Uid: "OVER_DUE_PAID_SUPPLIER", Value: "Supplierwise" },
];

export const BinwiseStockDueDetailData = [
  { Uid: "DUE_DETAIL", Value: "Detail" },
  { Uid: "DUE_ITEMS", Value: "Itemwise" },
  { Uid: "DUE_BRAND", Value: "Brandwise" },
  { Uid: "DUE_MAIN_GRP", Value: "MainGrpwise" },
  { Uid: "DUE_SUB_GRP", Value: "SubGrpwise" },
  { Uid: "DUE_GRP", Value: "Grpwise" },
  { Uid: "DUE_SUPPLIER", Value: "Supplierwise" },
];
export const ItemswiseData = [
  // { Uid: "ITM_DETAIL", Value: "Detail" },
  { Uid: "ITM_CONS", Value: "Itemwise" },
  { Uid: "ITM_BRAND", Value: "Brandwise" },
  { Uid: "ITM_MAIN_GRP", Value: "MainGrpwise" },
  { Uid: "ITM_SUB_GRP", Value: "SubGrpwise" },
  { Uid: "ITM_GRP", Value: "Grpwise" },
  { Uid: "ITM_SUPPLIER", Value: "Supplierwise" },
];

export const sWMSStockReportCheckboxInit = {
  sProperty1Data: false,
  sProperty2Data: false,
  sProperty3Data: false,
  sProperty4Data: false,
  sAnalysis1Data: false,
  sAnalysis2Data: false,
  sAnalysis3Data: false,
  sAnalysis4Data: false,
  sAnalysis5Data: false,
  sAnalysis6Data: false,
  sAnalysis7Data: false,
};
export const sBufferObjInit = {
  //BinRadiobtn
  sDetailReportRadioBtnName: "BINWISE_DETAIL",
  ItemwiseDropdown: ItemswiseData[0].Uid,
  BinwiseStockDueDetailDropdown: BinwiseStockDueDetailData[0].Uid,
  BinwiseStockPaidDropdown: BinwiseStockPaidData[0].Uid,
  BinwiseStockOverDueDropdown: BinwiseStockOverDueData[0].Uid,
  ExpiredItemDropdown: ExpiredItemData[0].Uid,
  ExpiredItemDate: new Date(),
  NearExpiryDropdown: NearExpirData[0].Uid,
  NearExpiryDate: new Date(),
};
export const HeadObjectInit = {
  sLocation: "Is",
  sMainGroup: "All",
  sSubGroup: "All",
  sCategory: "All",
  sMainSupplier: "All",
  sBrand: "All",
  sItem: "All",
  sCardId: "All",
  sAisle: "All",
  sLevel: "All",
  sBinType: "All",
  sBin: "All",
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sMainGroupArr: [],
  sMainGroupPrnt: "",
  sMainGroupCode: "",
  sMainGroupName: "",
  sSubGroupArr: [],
  sSubGroupPrnt: "",
  sSubGroupCode: "",
  sSubGroupName: "",
  sCategoryArr: [],
  sCategoryPrnt: "",
  sCategoryCode: "",
  sCategoryName: "",
  sMainSupplierArr: [],
  sMainSupplierPrnt: "",
  sMainSupplierCode: "",
  sMainSupplierName: "",
  sSupplierSearchValue: "",
  sBrandArr: [],
  sBrandPrnt: "",
  sBrandCode: "",
  sBrandName: "",
  sBrandSearchValue: "",
  sBrandCategoryArr: [],
  sBrandCategoryPrnt: "",
  sBrandCategoryCode: "",
  sBrandCategoryName: "",
  sItemCode: "",
  sItemName: "",
  sCardIdFrom: "",
  sCardIdTo: "",
  sAisleArr: [],
  sAislePrnt: "",
  sAisleCode: "",
  sAisleName: "",
  sLevelArr: [],
  sLevelPrnt: "",
  sLevelCode: "",
  sLevelName: "",
  sBinTypeArr: [],
  sBinTypePrnt: "",
  sBinTypeCode: "",
  sBinTypeName: "",
  sBinFromCode: "",
  sBinFromName: "",
  sBinToCode: "",
  sBinToName: "",

  //analysis

  sProperty1: "All",
  sProperty1Arr: [],
  sProperty1Prnt: "",
  sProperty1Code: "",
  sProperty1Name: "",
  sProperty2: "All",
  sProperty2Arr: [],
  sProperty2Prnt: "",
  sProperty2Code: "",
  sProperty2Name: "",
  sProperty3: "All",
  sProperty3Arr: [],
  sProperty3Prnt: "",
  sProperty3Code: "",
  sProperty3Name: "",
  sProperty4: "All",
  sProperty4Arr: [],
  sProperty4Prnt: "",
  sProperty4Code: "",
  sProperty4Name: "",
  sAnalysis1: "All",
  sAnalysis1Arr: [],
  sAnalysis1Prnt: "",
  sAnalysis1Code: "",
  sAnalysis1Name: "",
  sAnalysis2: "All",
  sAnalysis2Arr: [],
  sAnalysis2Prnt: "",
  sAnalysis2Code: "",
  sAnalysis2Name: "",
  sAnalysis3: "All",
  sAnalysis3Arr: [],
  sAnalysis3Prnt: "",
  sAnalysis3Code: "",
  sAnalysis3Name: "",
  sAnalysis4: "All",
  sAnalysis4Arr: [],
  sAnalysis4Prnt: "",
  sAnalysis4Code: "",
  sAnalysis4Name: "",
  sAnalysis5: "All",
  sAnalysis5Arr: [],
  sAnalysis5Prnt: "",
  sAnalysis5Code: "",
  sAnalysis5Name: "",
  sAnalysis6: "All",
  sAnalysis6Arr: [],
  sAnalysis6Prnt: "",
  sAnalysis6Code: "",
  sAnalysis6Name: "",
  sAnalysis7: "All",
  sAnalysis7Arr: [],
  sAnalysis7Prnt: "",
  sAnalysis7Code: "",
  sAnalysis7Name: "",
};
export const DropDownDummydata = [
  {
    Cd: "01",
    Name1: "FMCG FOOD",
  },
  {
    Cd: "02",
    Name1: "FMCG NON FOOD",
  },
  {
    Cd: "03",
    Name1: "HEALTH AND BEAUTY",
  },
  {
    Cd: "04",
    Name1: "CHILLED AND DIARY",
  },
  {
    Cd: "05",
    Name1: "FROZEN FOODS",
  },
  {
    Cd: "07",
    Name1: "BAKERY",
  },
  {
    Cd: "08",
    Name1: "ROASTERY",
  },
  {
    Cd: "11",
    Name1: "BEVERAGES",
  },
  {
    Cd: "13",
    Name1: "ELECTRONICS",
  },
  {
    Cd: "14",
    Name1: "HOUSEHOLD",
  },
  {
    Cd: "15",
    Name1: "STAPLES",
  },
  {
    Cd: "16",
    Name1: "STATIONERY DEP",
  },
  {
    Cd: "17",
    Name1: "TOYS  & SPORTS",
  },
  {
    Cd: "18",
    Name1: "GARMENTS",
  },
  {
    Cd: "19",
    Name1: "TEXTILES",
  },
  {
    Cd: "20",
    Name1: "HOME FURNISHING",
  },
  {
    Cd: "21",
    Name1: "FOOT WEAR",
  },
  {
    Cd: "22",
    Name1: "LUGGAGE",
  },
  {
    Cd: "23",
    Name1: "JEWELLERIES & ACCESSORIES",
  },
  {
    Cd: "24",
    Name1: "SHOP CONSUMPTION",
  },
  {
    Cd: "25",
    Name1: "TELEPHONE CARDS",
  },
  {
    Cd: "26",
    Name1: "TOBACCO&ACC",
  },
  {
    Cd: "99",
    Name1: "FRESH ITEMS",
  },
];

export const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const fWmsStockRepotBrandArr = async (
  xGroupStructureObj,
  setGroupData
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotBrand = async (setGroupData) => {
  const CurrentMaingroupArr = await common_brandgroup_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotMainSupplier = async (setGroupData) => {
  const CurrentMaingroupArr = await common_VendorListReport_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};

export const fWmsStockRepotHeadObj = async (
  xGroupStructureObj,
  setHeadObject,
  xkey
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setHeadObject((obj) => ({
      ...obj,
      xkey: CurrentMaingroupArr?.data?.ResultSet,
    }));
  }
};

export const GetLocation = async (setLocation) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  //v_AnyData,v_Cd,v_Name,v_Distri,v_UserCd
  var vLocobj = {
    v_AnyData: "",
    v_Cd: "",
    v_Name: "",
    v_Distri: "Y",
    v_UserCd: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLocobj);
  const vLocation = await common_LocationSearch_GETROW(FinalObj);
  if (vLocation?.status === 200) {
    setLocation(vLocation?.data?.ResultSet);
  }
};
export const GetBinAttribute = async (
  setAisleData,
  setLevelData,
  setBinTypeData
) => {
  const vLocation = await common_BinAttributes_GETROW("");
  if (vLocation?.status === 200) {
    setAisleData(vLocation?.data?.ResultSet?.Aisle);
    setLevelData(vLocation?.data?.ResultSet?.Level);
    setBinTypeData(vLocation?.data?.ResultSet?.BinType);
  }
};

export const GetItemsAnalysis = async (
  setProperty1Data,
  setProperty2Data,
  setProperty3Data,
  setProperty4Data,
  setAnalysis1Data,
  setAnalysis2Data,
  setAnalysis3Data,
  setAnalysis4Data,
  setAnalysis5Data,
  setAnalysis6Data,
  setAnalysis7Data
) => {
  const vLocation = await common_ItemsAnalsys_GETROW("");
  if (vLocation?.status === 200) {
    setProperty1Data(vLocation?.data?.ResultSet?.Property1);
    setProperty2Data(vLocation?.data?.ResultSet?.Property2);
    setProperty3Data(vLocation?.data?.ResultSet?.Property3);
    setProperty4Data(vLocation?.data?.ResultSet?.Property4);
    setAnalysis1Data(vLocation?.data?.ResultSet?.Analysis1);
    setAnalysis2Data(vLocation?.data?.ResultSet?.Analysis2);
    setAnalysis3Data(vLocation?.data?.ResultSet?.Analysis3);
    setAnalysis4Data(vLocation?.data?.ResultSet?.Analysis4);
    setAnalysis5Data(vLocation?.data?.ResultSet?.Analysis5);
    setAnalysis6Data(vLocation?.data?.ResultSet?.Analysis6);
    setAnalysis7Data(vLocation?.data?.ResultSet?.Analysis7);
  }
};

export const GetItemFullSearchArr = async (xItemName) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: "", //by sir
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};
export const GetSearchItem = async (xData, xType, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: "", //by sir
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await common_ItemsSearchReport_GETROW(FinalObj);
  if (vItemSearch?.status === 200) {
    let vItemSearchArr = vItemSearch?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
export const fValidationHead_Client = (HeadObject) => {
  let iRes = true;

  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sMainGroup.toUpperCase() === "IS" &&
    HeadObject.sMainGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "MainGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sSubGroup.toUpperCase() === "IS" &&
    HeadObject.sSubGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "sSubGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sCategory.toUpperCase() === "IS" &&
    HeadObject.sCategoryPrnt === ""
  ) {
    fAlertToast("FAILED", "sCategory should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sMainSupplier.toUpperCase() === "IS" &&
    HeadObject?.sMainSupplierArr.map((x) => x.AcCd).join(",") === ""
  ) {
    fAlertToast("FAILED", "sMainSupplier should not be empty");
    iRes = false;
    return iRes;
  }

  // if (
  //   HeadObject.sBrand.toUpperCase() === "IS" &&
  //   HeadObject.sBrandPrnt === ""
  // ) {
  //   fAlertToast("FAILED", "sBrand should not be empty");
  //   iRes = false;
  //   return iRes;
  // }
  if (
    HeadObject.sBrand.toUpperCase() === "IS" &&
    HeadObject?.sBrandArr.map((x) => x.UID).join(",") === ""
  ) {
    fAlertToast("FAILED", "sBrandCategory should not be empty");
    iRes = false;
    return iRes;
  }
  if (HeadObject.sItem.toUpperCase() === "IS" && HeadObject.sItemCode === "") {
    fAlertToast("FAILED", "sItemCode should not be empty");
    iRes = false;
    return iRes;
  }
  if (HeadObject.sItem.toUpperCase() === "IS" && HeadObject.sItemName === "") {
    fAlertToast("FAILED", "sItemName should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sCardId.toUpperCase() === "IS" &&
    HeadObject.sCardIdFrom === ""
  ) {
    fAlertToast("FAILED", "sCardId should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAisle.toUpperCase() === "IS" &&
    HeadObject.sAislePrnt === ""
  ) {
    fAlertToast("FAILED", "sAisle should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sLevel.toUpperCase() === "IS" &&
    HeadObject.sLevelPrnt === ""
  ) {
    fAlertToast("FAILED", "sLevel should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sBinType.toUpperCase() === "IS" &&
    HeadObject.sBinTypePrnt === ""
  ) {
    fAlertToast("FAILED", "sBinType should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sBin.toUpperCase() === "IS" &&
    HeadObject.sBinFromCode === ""
  ) {
    fAlertToast("FAILED", "sBin should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sProperty1.toUpperCase() === "IS" &&
    HeadObject.sProperty1Prnt === ""
  ) {
    fAlertToast("FAILED", "sProperty1 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sProperty2.toUpperCase() === "IS" &&
    HeadObject.sProperty2Prnt === ""
  ) {
    fAlertToast("FAILED", "sProperty2 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sProperty3.toUpperCase() === "IS" &&
    HeadObject.sProperty3Prnt === ""
  ) {
    fAlertToast("FAILED", "sProperty3 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sProperty4.toUpperCase() === "IS" &&
    HeadObject.sProperty4Prnt === ""
  ) {
    fAlertToast("FAILED", "sProperty4 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis1.toUpperCase() === "IS" &&
    HeadObject.sAnalysis1Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis1 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis2.toUpperCase() === "IS" &&
    HeadObject.sAnalysis2Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis2 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis3.toUpperCase() === "IS" &&
    HeadObject.sAnalysis3Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis3 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis4.toUpperCase() === "IS" &&
    HeadObject.sAnalysis4Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis4 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis5.toUpperCase() === "IS" &&
    HeadObject.sAnalysis5Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis5 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis6.toUpperCase() === "IS" &&
    HeadObject.sAnalysis6Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis6 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis7.toUpperCase() === "IS" &&
    HeadObject.sAnalysis7Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis7 should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};
export const fValidationDetail_Client = (sBufferObj, HeadObject) => {
  let iRes = true;
  if (
    sBufferObj.sDetailReportRadioBtnName === "" ||
    sBufferObj.sDetailReportRadioBtnName === null ||
    sBufferObj.sDetailReportRadioBtnName === undefined
  ) {
    fAlertToast("FAILED", "DetailReport should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    sBufferObj.sDetailReportRadioBtnName === "BIN_LEDGER" &&
    HeadObject.sItem?.toUpperCase() === "IS" &&
    HeadObject.sItemCode?.toUpperCase() === ""
  ) {
    fAlertToast("FAILED", "Item should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "ITEMSWISE" &&
    (sBufferObj.ItemwiseDropdown === "" ||
      sBufferObj.ItemwiseDropdown === null ||
      sBufferObj.ItemwiseDropdown === undefined)
  ) {
    fAlertToast("FAILED", "ItemwiseDropdown should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "NR_EXP" &&
    (sBufferObj.NearExpiryDate === "" ||
      sBufferObj.NearExpiryDate === null ||
      sBufferObj.NearExpiryDate === undefined ||
      sBufferObj.ExpiredItemDate === "Invalid Date")
  ) {
    fAlertToast("FAILED", "NearExpiryDate should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "NR_EXP" &&
    (sBufferObj.NearExpiryDropdown === "" ||
      sBufferObj.NearExpiryDropdown === null ||
      sBufferObj.NearExpiryDropdown === undefined)
  ) {
    fAlertToast("FAILED", "NearExpiryDropdown should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "EXP_ITEM" &&
    (sBufferObj.ExpiredItemDate === "" ||
      sBufferObj.ExpiredItemDate === null ||
      sBufferObj.ExpiredItemDate === undefined ||
      sBufferObj.ExpiredItemDate === "Invalid Date")
  ) {
    fAlertToast("FAILED", "ExpiredItemDate should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "EXP_ITEM" &&
    (sBufferObj.ExpiredItemDropdown === "" ||
      sBufferObj.ExpiredItemDropdown === null ||
      sBufferObj.ExpiredItemDropdown === undefined)
  ) {
    fAlertToast("FAILED", "ExpiredItem should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "STK_BIN_OD" &&
    (sBufferObj.BinwiseStockOverDueDropdown === "" ||
      sBufferObj.BinwiseStockOverDueDropdown === null ||
      sBufferObj.BinwiseStockOverDueDropdown === undefined)
  ) {
    fAlertToast("FAILED", "BinwiseStockOverDueDropdown should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "STK_PAID" &&
    (sBufferObj.BinwiseStockPaidDropdown === "" ||
      sBufferObj.BinwiseStockPaidDropdown === null ||
      sBufferObj.BinwiseStockPaidDropdown === undefined)
  ) {
    fAlertToast("FAILED", "BinwiseStockPaidDropdown should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "STK_DUE" &&
    (sBufferObj.BinwiseStockDueDetailDropdown === "" ||
      sBufferObj.BinwiseStockDueDetailDropdown === null ||
      sBufferObj.BinwiseStockDueDetailDropdown === undefined)
  ) {
    fAlertToast("FAILED", "BinwiseStockDueDetailDropdown should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};
